import { render, staticRenderFns } from "./userranking.vue?vue&type=template&id=57479017&"
import script from "./userranking.vue?vue&type=script&lang=js&"
export * from "./userranking.vue?vue&type=script&lang=js&"
import style0 from "./userranking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports